document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.mobile-menu-button');
  const mobileNav = document.querySelector('.mobile-nav');
  if (menuButton && mobileNav) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      mobileNav.hidden = open;
    });
  }

  document.querySelectorAll('.quick-add form').forEach(form => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button');
      const original = button.textContent;
      button.textContent = 'ADDING...';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/x-www-form-urlencoded','Accept':'application/json'},
          body: new URLSearchParams(new FormData(form))
        });
        if (!response.ok) throw new Error('Cart error');
        const cart = await fetch('/cart.js').then(r => r.json());
        document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
        button.textContent = 'ADDED ✓';
        setTimeout(() => button.textContent = original, 1500);
      } catch (e) {
        form.submit();
      }
    });
  });
});